import React from "react";
import styles from "../styles/pages/contact.module.css"
import GithubIcon from "../assets/github_logo.svg"
import InstaIcon from "../assets/instagram.svg"
import DiscordIcon from "../assets/discord.svg"
import MailIcon from "../assets/mail.svg"

function Contact() {
    return (<div className={styles.contact}>
        <div className={styles.links}>
            <ul>
                <li className={styles.link}><a href="https://github.com/thebrainfox44" target="_blank" rel="noreferrer"><img src={GithubIcon} alt="Github icon"/></a></li>
                <li className={styles.link}><a href="https://instagram.com/souhail.nts/" target="_blank" rel="noreferrer"><img src={InstaIcon} alt="Instagram icon"/></a></li>
                <li className={styles.link}><a href="https://discord.com/users/823825738117021716" target="_blank" rel="noreferrer"><img src={DiscordIcon} alt="Discord icon"/></a></li>
                <li className={styles.link}><a href="mailto:contact@thebrainfox.com" target="_blank" rel="noreferrer"><img src={MailIcon} alt="Mail icon"/></a></li>
            </ul>
        </div>
        <div>
            <h1>My contact informations</h1>
            <div className={styles.infos}>
                <div className={styles.line}><span className={styles.left}>Mail</span><span className={styles.right}><a href="mailto:Contact@thebrainfox.com" className={styles.mail}>Contact@thebrainfox.com</a></span></div>
                <div className={styles.line}><span className={styles.left}>Phone</span><span className={styles.right}>(+33) 6 16 14 10 44</span></div>
            </div>
        </div>
    </div>);
}

export default Contact;